export default __webpack_public_path__ + "static/media/edit-icon-grey.cf8353d9.svg";